import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import dashboard from './modules/dashboard'
import proxy from './modules/proxy'
import billing from './modules/billing'
import account from './modules/account'
import app from './modules/app'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    dashboard,
    proxy,
    billing,
    account,
    app
  },
  getters
})